import { render, staticRenderFns } from "./DashboardPresetBar.vue?vue&type=template&id=4dc8979c&scoped=true"
import script from "./DashboardPresetBar.vue?vue&type=script&lang=js"
export * from "./DashboardPresetBar.vue?vue&type=script&lang=js"
import style0 from "./DashboardPresetBar.vue?vue&type=style&index=0&id=4dc8979c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc8979c",
  null
  
)

export default component.exports